import React from "react";
import AnimatedWaves from "./AnimatedWaves";
import AutoVideo from "./AutoVideo";
import LogoRevealBg from "./LogoRevealBg";

// Renders the portfolio background FIXED to the viewport, so the image/video
// always fills the device screen at its exact size and the content (menu /
// cells) scrolls over it. This keeps the media crisp and avoids stretching.
const PortfolioBackground = ({ background }) => {
  const type = background?.type || "aurora";
  const url = background?.url;

  if (type === "image" && url) {
    return (
      <div className="pf-fixed-bg">
        <img
          src={url}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/80" />
      </div>
    );
  }

  if (type === "video" && url) {
    return (
      <div className="pf-fixed-bg">
        <AutoVideo
          className="absolute inset-0 h-full w-full object-cover"
          src={url}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/80" />
      </div>
    );
  }

  if (type === "logo3d") {
    return (
      <div className="pf-fixed-bg">
        <LogoRevealBg logo={background?.logo} glow={background?.glow} />
      </div>
    );
  }

  // Animated waves — also fixed to the viewport for a consistent feel.
  return (
    <div className="pf-fixed-bg">
      <AnimatedWaves />
    </div>
  );
};

export default PortfolioBackground;
